import { makeQuery } from 'shared/utilities';
import { IDepartmentBranchModel } from 'shared/models';
import { ObjectType } from 'shared/types';

type ResponseType = {
    items: IDepartmentBranchModel[];
};

export const vacanciesDepartmentBranchesQuery = async function (params: ObjectType = {}) {
    return await makeQuery<ResponseType>('/vacancies/department-branches', { params });
}
